import {Button, ButtonProps} from "@progress/kendo-react-buttons";
import {VivoPortal} from "@utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;
import './FlintIconButton.scss'
import FlintIcon from "@components/controls/buttons/FlintIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

export default function FlintIconButton(props: FlintIconButtonProps) {
    const {themeColor = "secondary", type = "button", className, iconEnum, faIcon, spin, disabled, ...others} = props;
    const c = className ? `icon-btn ${className}` : "icon-btn";

    return (
        <Button className={c} themeColor={disabled == true ? "secondary" : themeColor} type={type} disabled={disabled} {...others}>
            {faIcon ? <FontAwesomeIcon icon={faIcon} spin={spin}/> : <FlintIcon iconEnum={iconEnum}/>}
        </Button>
    )
}

export interface FlintIconButtonProps extends ButtonProps {
    iconEnum?: EnumIconButtonDefaultType;
    faIcon?: IconDefinition;
    spin?: boolean;
}